// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaPendingTag from './logic'

export default function TysiaPendingTagFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaPendingTag">
      <TysiaPendingTag {...props}>
        {children}
      </TysiaPendingTag>
    </Flow>
  )
}
